import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import AboutFour from '../Components/About/AboutFour'
import OfferTwo from '../Components/Offer/OfferTwo'
import ElementSection from '../Components/Elements/ElementSection'
import TourGuideTwo from '../Components/Guide/TourGuideTwo'
import TestimonialOne from '../Components/Testimonials/TestimonialOne'
import GalleryFive from '../Components/Gallery/GalleryFive'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import { useSiteContent, sectionField } from '../hooks/useSiteContent'
import { usePageBanner } from '../hooks/usePageBanner'
import { getImageUrl } from '../utils/imageUrl'

function About() {
    const { content } = useSiteContent('about')
    const fallbackTitle = sectionField(content, 'breadcrumb', 'title', 'About Travel With Ammar')
    const contentBanner = getImageUrl(sectionField(content, 'breadcrumb', 'banner_image', ''))
    const { title, bgImage } = usePageBanner({
        pageSlug: 'about',
        fallbackTitle,
        fallbackImage: contentBanner,
    })

    return (
        <>
            <HeaderOne />
            <Breadcrumb title={title} bgImage={bgImage} />
            <AboutFour />
            <OfferTwo />
            <ElementSection />
            <TourGuideTwo />
            <TestimonialOne />
            <GalleryFive />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default About
